.picture {
  display: contents;
}
